import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .tooltip' ) )
     .forEach( tooltipNode => new Tooltip( tooltipNode ) )
